var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalysisIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 284.9 372.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.7,222.4H210V305h-23.8c-6.2,0-11.2,5-11.2,11.2c0,6.2,5,11.2,11.2,11.2h70c6.2,0,11.2-5,11.2-11.2 c0-6.2-5-11.2-11.2-11.2h-23.8v-82.6h41.3c6.2,0,11.2-5,11.2-11.2V88.7c0-6.2-5-11.2-11.2-11.2h-41.3V47.4h23.8 c6.2,0,11.2-5,11.2-11.2s-5-11.2-11.2-11.2h-70C180,25,175,30,175,36.2s5,11.2,11.2,11.2H210v30.1h-41.3c-6.2,0-11.2,5-11.2,11.2 v122.5C157.5,217.4,162.5,222.4,168.7,222.4L168.7,222.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.2,105H74.9V22.4h23.8c6.2,0,11.2-5,11.2-11.2S104.9,0,98.7,0h-70c-6.2,0-11.2,5-11.2,11.2s5,11.2,11.2,11.2h23.8V105 H11.2C5,105,0,110,0,116.2v192.5c0,6.2,5,11.2,11.2,11.2h41.3V350H28.7c-6.2,0-11.2,5-11.2,11.2s5,11.2,11.2,11.2h70 c6.2,0,11.2-5,11.2-11.2s-5-11.2-11.2-11.2H74.9v-30.1h41.3c6.2,0,11.2-5,11.2-11.2V116.2C127.4,110,122.4,105,116.2,105L116.2,105 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysisIcon);
export default __webpack_public_path__ + "static/media/analysis-icon.ab26574a49fe23e791bdcce02c6b12cb.svg";
export { ForwardRef as ReactComponent };